<script setup lang="ts">
interface Props {
  blok: {
    title: string
    subtitle: string
    content: Array<{
      question: string
      answer: string
    }>
  }
}
defineProps<Props>()

const { colors } = useTheme()
</script>

<template>
  <section max-w="1280px" mx-auto class="py-[60px] md:py-[100px] px-[10px] md:px-0 col gap-[20px] md:gap-0 md:grid grid-cols-[380px_1fr]">
    <div class="col gap-[8px] md:pr-[50px]">
      <div>
        <div class="font-circular-bold text-[16px] tracking-[-0.64px] leading-[28px]" :style="{ color: colors.spGray3 }">
          {{ blok.title }}
        </div>
        <div class="font-circular-bold text-[31.99px] md:text-[45.23px] tracking-[-1.28px] md:tracking-[-1.809px] leading-[35.189px] md:leading-[49.753px]">
          {{ blok.subtitle }}
        </div>
      </div>
    </div>

    <div
      class="md:flex md:justify-end"
    >
      <ul
        class="md:max-w-[720px]"
        :style="{
          borderTop: '1px solid',
          borderTopColor: colors.spGray2,
        }"
      >
        <ExpansionPanel
          v-for="(item, index) in blok.content"
          :key="index"
          :color="colors.black"
          :color-hover="colors.black"
          :style="{
            borderBottom: '1px solid',
            borderBottomColor: colors.spGray2,
          }"
        >
          <slot name="title">
            <div class="flex w-full py-[36px] pr-3">
              <div class="text-[20px] font-inter font-bold leading-[24px] tracking-[-0.4px]">
                {{ item.question }}
              </div>
            </div>
          </slot>

          <template #expansion-panel-content>
            <div class="pt-[8px] pb-[20px]">
              <p whitespace-pre-wrap class="text-[16px] font-inter font-medium leading-[28px]">
                {{ item.answer }}
              </p>
            </div>
          </template>
        </ExpansionPanel>
      </ul>
    </div>
  </section>
</template>

<style module lang="scss">
.text {
  font-size: 16px !important;
  line-height: 175% !important;
}
</style>
